import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import SalesforceBulkWriterForm from '../forms/salesforce-bulk-writer-form';
import { salesforceBulkWriterValidationSchema } from '../schema/salesforceBulkWriter';

export default function SalesforceBulkWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Salesforce Bulk Writer Node Details',
        altText: 'Salesforce Bulk Writer Node',
        defaultLabel: 'Salesforce Bulk Writer Node',
      }}
    >
      <CommonNode
        FormComponent={SalesforceBulkWriterForm}
        schemaResolver={salesforceBulkWriterValidationSchema}
      />
    </NodeProvider>
  );
}
